export default __webpack_public_path__ + "static/media/product_01.e2edd906.jpg";